import React, {useContext} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import PropTypes from 'prop-types';
import {UserContext} from '../context/UserContext';

const ProtectedRoute = ({role, children}) => {
    const {user, loading} = useContext(UserContext);
    if (loading) return <div style={{padding: 32}}>Restoring session…</div>;
    if (!user) return <Navigate to="/login" replace/>;
    if (role && user.role !== role) return <Navigate to="/unauthorized" replace/>;
    return children ?? <Outlet/>;
};

ProtectedRoute.propTypes = {children: PropTypes.node, role: PropTypes.string};
export default ProtectedRoute;
